import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const ReturnRefundPolicy = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          <h1 className="text-2xl font-bold tracking-tight">SAANJH</h1>
          <Button variant="ghost" onClick={() => navigate('/')}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Button>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold tracking-tight mb-4">Return &amp; Refund Policy</h1>
        <p className="text-muted-foreground mb-8">Last updated: June 2026</p>

        <div className="prose prose-slate max-w-none space-y-8">
          <section>
            <div className="rounded-lg border border-amber-300 bg-amber-50 p-5">
              <p className="text-amber-900 font-semibold mb-1">No Returns &amp; No Refunds</p>
              <p className="text-amber-800 leading-relaxed text-sm">
                All sales made through SAANJH are final. We do not accept returns and do not offer
                refunds on any order once it has been placed.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">1. Overview</h2>
            <p className="text-muted-foreground leading-relaxed">
              SAANJH ("we," "our," or "us") operates an online platform at saanjh.cc that enables independent
              businesses to sell their products and services. This Return &amp; Refund Policy applies to all
              purchases made through stores hosted on the SAANJH platform.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">2. No Returns</h2>
            <p className="text-muted-foreground leading-relaxed">
              We do not accept returns of any products purchased through the platform. Once an order is
              confirmed and placed, it cannot be returned or exchanged.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">3. No Refunds</h2>
            <p className="text-muted-foreground leading-relaxed">
              All payments are non-refundable. Once a payment has been successfully processed, no refund will
              be issued for the order, in whole or in part, except where a refund is expressly required by
              applicable law.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">4. Order Cancellation</h2>
            <p className="text-muted-foreground leading-relaxed">
              As all sales are final, orders cannot be cancelled once placed. Please review your order
              carefully — including items, quantities, and delivery details — before completing your purchase.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">5. Damaged or Incorrect Items</h2>
            <p className="text-muted-foreground leading-relaxed">
              While returns and refunds are not available, if you receive an item that is damaged or
              incorrect, please contact the seller directly through the store, or reach out to us at the
              details below, so the seller may assist you at their discretion. Any resolution offered is
              provided solely by the independent seller and is not a guarantee of a refund or return.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">6. Contact Us</h2>
            <p className="text-muted-foreground leading-relaxed">
              If you have questions about this Return &amp; Refund Policy, contact us at:
            </p>
            <div className="mt-3 text-muted-foreground leading-relaxed">
              <p>SAANJH</p>
              <p>C/O ItsMeHere, SBS Nagar</p>
              <p>Ludhiana, Punjab — 141001, India</p>
              <p>Email: <a className="underline" href="mailto:admin@saanjh.cc">admin@saanjh.cc</a></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ReturnRefundPolicy;
